/* 	HubspotController

	1) Adds functionality to hubspot forms.

*/

class HubspotController {

	initialize() {
		this.addEventListeners();
	}

	// listeners

	addEventListeners() {
		window.addEventListener('message', this.#onMessage);
	}

	removeEventListeners() {
		window.removeEventListener('message', this.#onMessage);
	}

	// listener methods

	#onMessage = (e) => {
		if (e.data.type === 'hsFormCallback') {
			const formId = e.data.id;
			if (formId) {
				const $forms = document.body.querySelectorAll('[data-form-hubspot-id]');
				const matchingForms = [];
				for (let i = 0; i < $forms.length; i++) {
					const $form = $forms[i];
					if ($form.dataset.formHubspotId === formId) {
						matchingForms.push($form);
					}
				}

				let stateClass = '';
				let stateRemoveClass = '';

				switch (e.data.eventName) {
					case 'onBeforeFormInit':
					stateClass = 'is-form-before-init';
					break;

					case 'onFormFailedValidation':
					stateClass = 'is-form-validation-error';
					break;

					case 'onFormReady':
					stateClass = 'is-form-ready';
					this.removeAutoComplete(matchingForms);
					this.addHoverListeners(matchingForms);
					break;

					case 'onFormSubmit':
					stateClass = 'is-form-submit';
					stateRemoveClass = 'is-form-validation-error';
					break;

					case 'onFormSubmitted':
					stateClass = 'is-form-submit-complete';
					stateRemoveClass = 'is-form-validation-error';
					break;

					default:
					break;
				}

				if (stateClass) {
					for (let i = 0; i < matchingForms.length; i++) {
						const $form = matchingForms[i];
						$form.classList.add(stateClass);
					}
				}

				if (stateRemoveClass) {
					for (let i = 0; i < matchingForms.length; i++) {
						const $form = matchingForms[i];
						$form.classList.remove(stateRemoveClass);
					}
				}
			}
		}
	};

	removeAutoComplete(matchingForms) {
		for (let i = 0; i < matchingForms.length; i++) {
			const $form = matchingForms[i];
			const $inputsEmail = $form.querySelectorAll('input[type=email]');
			for (let k = 0; k < $inputsEmail.length; k++) {
				const $inputEmail = $inputsEmail[k];
				$inputEmail.setAttribute('autocomplete', 'off');
			}
		}
	}

	addHoverListeners(matchingForms) {
		for (let i = 0; i < matchingForms.length; i++) {
			const $form = matchingForms[i];
			const $inputSubmit = $form.querySelector('input[type=submit]');
			if ($inputSubmit) {
				const $wrapper = $inputSubmit.closest('[data-form-hover-detector]');
				if ($wrapper) {
					$inputSubmit.addEventListener('mouseenter', () => {
						$wrapper.classList.add('is-form-submit-hover');
					});

					$inputSubmit.addEventListener('mouseleave', () => {
						$wrapper.classList.remove('is-form-submit-hover');
					});
				}
			}
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}

export default new HubspotController();
